(function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
        initSmoothScroll();
        initNavbarScroll();
        initScrollAnimations();
        initCosmicOrb();
        console.log('Blue Love - Cosmic Wellness Loaded 💙✨');
    }

    // ================================
    // SMOOTH SCROLL
    // ================================
    function initSmoothScroll() {
        const links = document.querySelectorAll('a[href^="#"]');
        
        links.forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                const href = this.getAttribute('href');
                if (href === '#' || !href) return;
                
                const target = document.querySelector(href);
                if (target) {
                    e.preventDefault();
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
    }

    // ================================
    // NAVBAR SCROLL EFFECT
    // ================================
    function initNavbarScroll() {
        const nav = document.querySelector('.main-nav');
        if (!nav) return;

        let lastScroll = 0;

        window.addEventListener('scroll', function() {
            const currentScroll = window.pageYOffset;

            if (currentScroll > 100) {
                nav.style.background = 'rgba(0, 0, 0, 0.98)';
                nav.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.3)';
            } else {
                nav.style.background = 'rgba(0, 0, 0, 0.95)';
                nav.style.boxShadow = 'none';
            }

            lastScroll = currentScroll;
        });
    }

    // ================================
    // SCROLL ANIMATIONS
    // ================================
    function initScrollAnimations() {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            });
        }, observerOptions);

        // Observe all cards and sections
        const elements = document.querySelectorAll('.product-card, .benefit-item, .philosophy-text');
        elements.forEach(function(el) {
            el.style.opacity = '0';
            el.style.transform = 'translateY(30px)';
            el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
            observer.observe(el);
        });
    }

    // ================================
    // COSMIC ORB INTERACTION
    // ================================
    function initCosmicOrb() {
        const orb = document.querySelector('.orb-inner');
        if (!orb) return;

        document.addEventListener('mousemove', function(e) {
            const x = e.clientX / window.innerWidth;
            const y = e.clientY / window.innerHeight;
            
            const moveX = (x - 0.5) * 20;
            const moveY = (y - 0.5) * 20;
            
            orb.style.transform = 'translate(calc(-50% + ' + moveX + 'px), calc(-50% + ' + moveY + 'px))';
        });
    }

    // ================================
    // PARALLAX EFFECT FOR HERO
    // ================================
    window.addEventListener('scroll', function() {
        const scrolled = window.pageYOffset;
        const hero = document.querySelector('.hero-content');
        
        if (hero && scrolled < window.innerHeight) {
            hero.style.transform = 'translateY(' + (scrolled * 0.5) + 'px)';
            hero.style.opacity = 1 - (scrolled / window.innerHeight);
        }
    });

    // ================================
    // SHOPIFY ADD TO CART
    // ================================
    
    // Update cart count when page loads
    function updateCartCount() {
        if (typeof Shopify !== 'undefined' && Shopify.cart) {
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    const cartLink = document.querySelector('.cart-link');
                    if (cartLink) {
                        cartLink.textContent = 'Cart (' + cart.item_count + ')';
                    }
                })
                .catch(error => console.error('Cart update error:', error));
        }
    }

    // Call on page load
    updateCartCount();

    // Listen for Shopify cart updates
    document.addEventListener('cart:updated', updateCartCount);

})();
